import { render, staticRenderFns } from "./IdealToUpSuccess.vue?vue&type=template&id=7660b036&scoped=true&"
import script from "./IdealToUpSuccess.vue?vue&type=script&lang=js&"
export * from "./IdealToUpSuccess.vue?vue&type=script&lang=js&"
import style0 from "./IdealToUpSuccess.vue?vue&type=style&index=0&id=7660b036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7660b036",
  null
  
)

export default component.exports